import { createMediaButton } from "../create-media-button.js";
import { SeekButtonCore, SeekButtonDataAttrs } from "@videojs/core";
import { selectTime } from "@videojs/core/dom";
//#region src/ui/seek-button/component.tsx
/**
* A button that seeks forward or backward by a configurable number of seconds.
*
* @example
*   ```tsx
*   <SeekButton seconds={-10} />
*
*   <SeekButton
*   seconds={30}
*   render={(props, state) => (
*   <button {...props}>
*   {state.direction === 'backward' ? <RewindIcon /> : <FastForwardIcon />}
*   </button>
*   )}
*   />
*   ```;
*/
const SeekButton = createMediaButton({
	displayName: "SeekButton",
	core: SeekButtonCore,
	stateAttrMap: SeekButtonDataAttrs,
	selector: selectTime,
	action: (core, state) => core.seek(state),
	hotkeyAction: "seekStep",
	hotkeyValue: (props) => typeof props.seconds === "number" ? props.seconds : SeekButtonCore.defaultProps.seconds
});
//#endregion
export { SeekButton };

//# sourceMappingURL=component.js.map